import { render } from "./OuterDetailPage.vue?vue&type=template&id=eeba28da&scoped=true&ts=true"
import script from "./OuterDetailPage.vue?vue&type=script&lang=ts"
export * from "./OuterDetailPage.vue?vue&type=script&lang=ts"

import "./OuterDetailPage.vue?vue&type=style&index=0&id=eeba28da&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeba28da"]])

export default __exports__